import ExternalLayout from './ExternalLayout';

export default ExternalLayout;
